// generated from 2_734 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xSoftBouncesInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_soft_bounces_in_y_days"),
  comparison_key: z.enum([
    "5", // 1_776 (64.96%)
    "1", // 485 (17.74%)
    "6", // 239 (8.74%)
    "3", // 185 (6.77%)
    "4", // 49 (1.79%)
  ]),
  display_name: z.string(),
  // undefined: 291 (10.64%), defined 2_443 (89.36%)
  raw_value: z
    .object({
      num_days: z.int().min(1).max(30),
      num_occurrences: z.int().min(0),
    })
    .optional(),
  value: z.object({
    num_days: z.int().min(1).max(30),
    num_occurrences: z.int().min(0),
  }),
  varies_by_app_group: z.literal(false),
});
